import { motion } from "framer-motion";
import Marquee from "react-fast-marquee";

const chapters = [
  {
    n: "N°1",
    title: "About Us",
    body: "Established in 2018, WVE Studios (formerly KALM Creative) is a central hub for creative digital media & event production — with over 20 years of combined industry experience.",
  },
  {
    n: "N°2",
    title: "Videography",
    body: "We've spent 10 years creating bespoke video for events, businesses and artists. Live events, promos, dance & theatre schools, festivals, music videos and more. All prices bespoke — any project, no matter the budget.",
  },
  {
    n: "N°3",
    title: "Event Production",
    body: "Staging, sound & lighting, videography and photography via trusted affiliated companies, as well as full in-house event production and management. From large-scale festivals to theatre-based dance shows, nothing is too big or too little.",
  },
];

const towns = ["BRENTWOOD", "BILLERICAY", "WICKFORD", "BASILDON", "SOUTHEND", "GRAYS", "WESTCLIFF", "LEIGH ON SEA", "CHELMSFORD", "MALDON"];

export const Manifesto = () => (
  <section id="studio" className="py-24 sm:py-32 bg-white border-y border-black/10" data-testid="manifesto-section">
    <div className="max-w-[1600px] mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-12">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="lg:col-span-4 lg:sticky lg:top-28 self-start"
      >
        <p className="text-sm uppercase tracking-[0.3em] font-semibold text-[#E80042] mb-4">03 — The Manifesto</p>
        <h2 className="font-grotesk font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-none">
          Who we are & why we're <span className="text-[#E80042]">loud</span> about it.
        </h2>
        <div className="mt-10 rounded-lg overflow-hidden rotate-1">
          <img loading="lazy"
            src="https://static.wixstatic.com/media/1fe187_6e45ad3c3f184b5bb568a3d84fbc41da~mv2.jpeg/v1/fill/w_700,h_820,al_c,q_85/studio.jpeg"
            alt="WVE Studios behind the scenes"
            className="w-full h-[340px] object-cover"
          />
        </div>
      </motion.div>

      <div className="lg:col-span-8 divide-y divide-black/10">
        {chapters.map((c, i) => (
          <motion.div
            key={c.n}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: i * 0.05 }}
            className="py-12 first:pt-0 grid sm:grid-cols-12 gap-4 group"
            data-testid={`manifesto-chapter-${i + 1}`}
          >
            <span className="sm:col-span-2 font-display text-3xl text-[#E80042]">{c.n}</span>
            <div className="sm:col-span-10">
              <h3 className="font-display uppercase text-3xl sm:text-4xl tracking-tight mb-4 group-hover:translate-x-2 transition-transform duration-300">{c.title}</h3>
              <p className="text-lg leading-relaxed text-[#555555] max-w-2xl">{c.body}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>

    <div className="mt-20 border-t border-black/10 pt-8" data-testid="coverage-marquee">
      <p className="text-center text-xs uppercase tracking-[0.3em] font-semibold text-[#555555] mb-6">Covering Essex & beyond</p>
      <Marquee speed={22} autoFill gradient={false}>
        {towns.map((t) => (
          <span key={t} className="font-grotesk font-bold text-2xl sm:text-3xl uppercase tracking-tight mx-6 flex items-center gap-6 text-[#0A0A0A]">
            {t} <span className="w-2.5 h-2.5 rounded-full bg-[#E80042] inline-block" />
          </span>
        ))}
      </Marquee>
    </div>
  </section>
);
